import templateUrl from './acknowledge-legal-notice.component.html'
import './acknowledge-legal-notice.component.less'
import { IQService } from 'angular';
import { UtilityService } from '../../core/services/utility.service';
import { LegalNoticeService } from '../../core/services';
import { SessionService } from '../../core/services/session.service';

export const AcknowledgeLegalNoticeComponent = {
    templateUrl,
    controller: class AcknowledgeLegalNoticeController {
        loaded = false;
        legalNotices: any[];
        legalNotice: any;
        isChecked = false;
        constructor(private $q: IQService, private utilityService: UtilityService,
            private legalNoticeService: LegalNoticeService,
            private sessionService: SessionService) {
            'ngInject';
        }

        $onInit() {
            this.loadLegalNotices();
        }

        private loadLegalNotices() {
            const loading = this.legalNoticeService.retrieveLegalNotices({ ShowLoggedInUserNotices: true })
                .then(notices => {
                    this.legalNotices = notices;
                    if (this.legalNotices) {
                        if (this.legalNotices.length > 0) {
                            this.legalNotice = this.legalNotices[0];
                            this.loaded = true;
                        } else {
                            // Refresh claims once all legal notices are acknowledged so that
                            // the claim indicating unacknowledged legal notices is removed.
                            return this.sessionService.renewClaims();
                        }
                    }
                });
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loading, "Loading legal notices failed")
            );
        }

        acknowledgeLegalNotice() {
            if (this.isChecked) {
                this.loaded = false;
                this.isChecked = false;
                this.utilityService.showLoading();
                this.legalNoticeService.acknowledgeLegalNoticeContent(this.legalNotice.LegalNoticeID,
                    this.legalNotice.CurrentLegalNoticeContent.LegalNoticeContentID)
                    .then(() => {
                        this.utilityService.hideLoading();
                        this.loadLegalNotices();
                    })
                    .catch(ex => {
                        this.utilityService.hideLoading();
                        alert("Loading legal notice failed: " + (ex.statusText || ex))
                    });

            }

        }
    },
    controllerAs: "vm"
}
